export const getQueryParams = <QueryParamToParse extends string>({
  href,
  queryParamsToParse,
}: {
  href: string;
  queryParamsToParse: QueryParamToParse[];
}): Record<QueryParamToParse, string | null> => {
  const url = new URL(href);

  return queryParamsToParse.reduce(
    (memo, curr) => {
      return {
        ...memo,
        [curr]: url.searchParams.get(curr),
      };
    },
    {} as Record<QueryParamToParse, string | null>,
  );
};
